// BE sends personalId as digits only, the slash is missing, but required by
// czechPIN validator, so we append slash to initialValues if exist
const firstSixDigitsRe = /^(\d{6})/;
export const addSlashToPersonalId = (personalId: string | undefined): string | undefined => {
	if (!personalId) {
		return personalId;
	}

	if (personalId.includes('/')) {
		return personalId;
	}

	return personalId.replace(firstSixDigitsRe, '$1/');
};
